import React, { useEffect } from 'react';
import PageLayout from 'components/layouts/PageLayout';
import SectionLayout from 'components/layouts/SectionLayout';
import TermsAndConditionContent from './content/TermsAndConditionContent';

const TermsAndCondition = () => {

    useEffect(() => {
        // Change Tab Title
        document.title = "Terms and Conditions - Insurance Enterprise"
    }, [])

    return (
        <>
            <PageLayout
                content={
                    <>
                        <SectionLayout content={<TermsAndConditionContent />} />
                    </>
                }
            />
        </>
    );
}

export default TermsAndCondition;
